import isObject from '../utility/isObject';
import ShipAddress from './shipAddress';

class ShipCity {
  public static fragmentsFields(): string {
    return `
      name
    `;
  }

  public static fromJson(value: any): ShipCity {
    if (!isObject(value)) {
      throw new TypeError('value must be an object for ShipCity.fromJson(value).');
    }

    const name = value['name'];
    const addresses = value['addresses'] ? value['addresses'].map((addressData: any) => {
      return ShipAddress.fromJson(addressData);
    }) : [];

    return new ShipCity({
      name,
      addresses,
    });
  }

  public name: string;
  public addresses: ShipAddress[];

  constructor({
    name = '',
    addresses = [],
  }: {
    name?: string;
    addresses?: ShipAddress[];
  }) {
    this.name = name;
    this.addresses = addresses;
  }
}

export default ShipCity;
